/**
 * Profile "link physical card" reuses the product-setup wizard, but its
 * dictionary only overrides flow-specific copy. CTA labels (next/create/…)
 * live on products.setup — merge so the footer is never an empty pill.
 */
export function mergeProfileLinkCardSetupCopy(
  productSetup: Record<string, string | undefined> | undefined,
  linkCard: Record<string, string | undefined> | undefined,
): Record<string, string | undefined> {
  const setup = productSetup ?? {};
  const card = linkCard ?? {};
  return {
    ...setup,
    ...card,
    step3bTitle: card.step2Title ?? setup.step3bTitle,
    step3bDescription: card.step2Description ?? setup.step3bDescription,
  };
}
